// Keep this in sync with the "version" field in package.json.
export const APP_VERSION = '0.7.1';

// Newest entry first. Add a new entry (or append to the top one) whenever
// the codebase changes, so the About page reflects what's new.
export const CHANGELOG = [
  {
    version: '0.7.1',
    date: '2026-09-21',
    changes: [
      'Fixed Spending Profile chart to properly exclude transactions and categories marked with auto_exclude flag, including transfers and other auto-categorized exclusions.',
    ],
  },
  {
    version: '0.7.0',
    date: '2026-09-13',
    changes: [
      'Reviewed and compared categories vs. divisions table architecture for future consolidation.',
      'Added Swibeco as a new bank account variant with proper currency and import integration.',
      'Fixed Spending Profile Chart to display fixed monthly amounts as flat lines even without transactions.',
      'Consolidated management of bank import pages with unified patterns and account selectors.',
      'Migrated development environment to Node.js 24 for improved performance and security.',
      'Aligned management of NSIS and MSIX builds for consistent Windows installer generation.',
    ],
  },
  {
    version: '0.6.0',
    date: '2026-09-11',
    changes: [
      'Standardized duplicate detection across all bank import routes (Revolut, Credit Mutuel, UBS, BUNQ, ASN, ICS, Credit Agricole).',
      'Implemented unified dual-layer duplicate detection: code-level query checks + schema-level UNIQUE constraint.',
      'Improved Revolut import reliability with SHA256-based unique key generation, protecting against edge-case race conditions.',
      'Enhanced system maintainability through consistent patterns across all supported banks.',
    ],
  },
  {
    version: '0.5.9',
    date: '2026-09-06',
    changes: [
      'Implemented remote SSH connection support for coding remotely, enabling secure access to the development environment from anywhere.',
    ],
  },
  {
    version: '0.5.8',
    date: '2026-08-26',
    changes: [
      'Refactored bank import architecture: unified all banks (Revolut, UBS, Credit Mutuel, etc.) on a single BankImportPage component for consistency and maintainability.',
      'Automated exchange rate proposition: live CHF→EUR rates now auto-populate from exchangerate-api.com when selecting non-EUR currency accounts.',
      'Added UBS integration with dynamic EUR/CHF endpoint routing based on selected account currency.',
      'Alphabetically sorted bank dropdowns and account lists across Settings, Import menu, and import pages.',
      'Implemented account selection (Own/Joint) and currency display in all bank import page titles for clarity.',
    ],
  },
  {
    version: '0.5.7',
    date: '2026-08-25',
    changes: [
      'Added Revolut bank integration for EUR/CHF multi-currency accounts.',
      'Deployed Pelmeshka to pelmeshka.ch with GitHub Pages hosting.',
      'Added download section in About page for direct access to latest Windows and macOS installers.',
    ],
  },
  {
    version: '0.5.6',
    date: '2026-08-09',
    changes: [
      'Added MSIX build target for Windows packaging alongside NSIS and portable installers.',
      'Pelmeshka can now be distributed via Microsoft Store and other package managers.',
    ],
  },
  {
    version: '0.5.4',
    date: '2026-08-02',
    changes: [
      'Renamed accounts table to sources in database for clearer semantics.',
      'Added /api/banks endpoint for bank reference data access.',
      'Removed ImportPlus page and related components.',
    ],
  },
  {
    version: '0.5.3',
    date: '2026-08-02',
    changes: [
      'Categories system: Implemented smart hybrid approach—auto-populate from existing data on first run, then user-managed only.',
      'Fixed category dropdown population in Auto Categorization and Transactions pages.',
      'Removed database blocking issues in category sync process.',
      'Added missing function exports for Budget and BAF pages.',
      'Corrected transaction classification column references.',
    ],
  },
  {
    version: '0.5.2',
    date: '2026-08-01',
    changes: [
      'BAF Table: Added configurable Real Saldo input field for manual balance adjustments.',
      'Theme and UI refinements across dashboard components.',
      'macOS build configuration improvements for better compatibility.',
    ],
  },
  {
    version: '0.5.0',
    date: '2026-08-01',
    changes: [
      'Added version and timestamp to GitHub Actions artifact names for build traceability.',
      'Updated favicon generation pipeline for multiple formats and sizes.',
      'Improved theme and color system with enhanced Material-UI integration.',
      'Build process refinements and GitHub Actions workflow optimizations.',
    ],
  },
  {
    version: '0.4.2',
    date: '2026-08-01',
    changes: [
      'BAF Table: Added interactive X and Y axis bounds controls with localStorage persistence.',
      'BAF Table: Improved styling—table background now matches chart for better readability.',
      'BAF Table: Amount values now display in their series color for visual consistency.',
      'BAF Table & Budget: Fixed initial load to display from M-2 (current month - 2) without jumping from January.',
    ],
  },
  {
    version: '0.4.1',
    date: '2026-08-01',
    changes: [
      'Added macOS app support (.dmg and .zip installers).',
      'Unified build pipeline: GitHub Actions now builds Windows and macOS apps in parallel.',
      'Added two-series auto-categorization performance chart showing success rate by transaction count and by absolute euro amounts.',
      'Restored History page with contributor acknowledgments.',
      'Added toggle to Budget page to control whether edits propagate to future months (auto-fill on/off).',
    ],
  },
  {
    version: '0.3.1',
    date: '2026-07-22',
    changes: [
      'Fixed a bug where deleted ABN transactions reappeared after reloading the app.',
    ],
  },
  {
    version: '0.3.0',
    date: '2026-07-22',
    changes: [
      'Added an About page showing the app version and change history.',
      'Set up GitHub Actions CI to automatically build the Windows installer.',
    ],
  },
];
